<div class="hero-3" id="hero">
    <div class="swiper hero-slider-3" id="heroSlide3">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="hero-inner">
                    <div class="th-hero-bg" data-bg-src="assets/img/hero/hero_bg_3_2.jpg">
                    </div>
                    <div class="container">
                        <div class="hero-style3">
                            <h1 class="hero-title" data-ani="slideinleft" data-ani-delay="0.2s">
                                Transforming <span class="text-info">Tomorrow</span> with AI, Today.
                            </h1>
                            <p class="hero-text" data-ani="slideinleft" data-ani-delay="0.4s">We deliver innovative,
                                intelligent solutions that help businesses evolve, adapt, and lead in an ever-changing
                                digital world.</p>
                            <div class="btn-group" data-ani="slideinup" data-ani-delay="0.6s">
                                <a routerLink="/services" class="th-btn th-icon">
                                    Our Services <i class="fa-light fa-arrow-right-long"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="swiper-slide">
                <div class="hero-inner">
                    <div class="th-hero-bg" data-bg-src="assets/img/hero/hero_9_3.jpg">
                    </div>
                    <div class="container">
                        <div class="hero-style3">
                            <h1 class="hero-title" data-ani="slideinleft" data-ani-delay="0.2s">
                                Building the <span class="text-info">Future</span>, one line of code at a time.
                            </h1>
                            <p class="hero-text" data-ani="slideinleft" data-ani-delay="0.4s">Customized Solutions, 100%
                                User Friendly Invest your money<br> in Developing a Brand, not just a website </p>
                            <div class="btn-group" data-ani="slideinup" data-ani-delay="0.6s">
                                <a routerLink="/services" class="th-btn th-icon">Our Services <i
                                        class="fa-light fa-arrow-right-long"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="swiper-slide">
                <div class="hero-inner">
                    <div class="th-hero-bg" data-bg-src="assets/img/hero/home-bg-video_short_9.jpeg">
                    </div>
                    <div class="container">
                        <div class="hero-style3">
                            <h1 class="hero-title" data-ani="slideinleft" data-ani-delay="0.2s">
                                We Provide Exclusive Worldwide Service
                            </h1>
                            <p class="hero-text" data-ani="slideinleft" data-ani-delay="0.4s">Welcome to Atek where we
                                specialize in delivering tailored technology and Cloud Computing solutions.</p>
                            <div class="btn-group" data-ani="slideinup" data-ani-delay="0.6s">
                                <a routerLink="/services" class="th-btn th-icon">Our Services <i
                                        class="fa-light fa-arrow-right-long"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="hero3-wrapper">
            <div class="container">
                <div class="hero3-featuredbox d-flex justify-content-center align-items-end">
                    <div class="hero3-feature-wrapp">
                        <div class="hero-featured d-md-flex align-items-center justify-content-between">
                            <div class="hero-featured-item text-center text-lg-start d-lg-flex align-items-center">
                                <span class="hero-featured-icon"><img src="assets/img/icon/hours.svg" alt=""></span>
                                <div class="hero-featured-content">
                                    <h3 class="hero-featured-title text-anime-style-2 fs-20px teko-500">Highest Success
                                        Rates
                                    </h3>
                                    <p class="sec-text">We Are Trusted Our Customers</p>
                                </div>
                            </div>
                            <div class="hero-featured-item text-center text-lg-start d-lg-flex align-items-center">
                                <span class="hero-featured-icon"><img src="assets/img/icon/chipset.svg" alt=""></span>
                                <div class="hero-featured-content">
                                    <h3 class="hero-featured-title text-anime-style-2 fs-20px teko-500">Effective Team
                                        Work</h3>
                                    <p class="sec-text">Our Results Speak for Themselves</p>
                                </div>
                            </div>
                            <div class="hero-featured-item text-center text-lg-start d-lg-flex align-items-center">
                                <span class="hero-featured-icon"><img src="assets/img/icon/users.svg" alt=""></span>
                                <div class="hero-featured-content">
                                    <h3 class="hero-featured-title text-anime-style-2 fs-20px teko-500">Effective Team
                                        Work</h3>
                                    <p class="sec-text">We Collaborate to Achieve More</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="hero-3thumbs">
                        <div class="hero3-swiper-custom">
                            <button data-slider-prev="#heroSlide3" class="swiper-button-next">
                                <img src="assets/img/icon/hero-arrow-right.svg" alt=""></button>
                            <div class="swiper-pagination"></div>
                            <button data-slider-next="#heroSlide3" class="swiper-button-prev">
                                <img src="assets/img/icon/hero-arrow-left.svg" alt="">
                            </button>
                        </div>
                        <div class="swiper hero3Thumbs d-none d-xl-block">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide">
                                    <div class="hero-inner">
                                        <div class="hero3-card">
                                            <div class="hero-img">
                                                <img src="assets/img/hero/hero_bg_3_2.jpg" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <div class="hero-inner">
                                        <div class="hero3-card">
                                            <div class="hero-img">
                                                <img src="assets/img/hero/hero_9_3.jpg" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <div class="hero-inner">
                                        <div class="hero3-card">
                                            <div class="hero-img">
                                                <img src="assets/img/hero/home-bg-video_short_9.jpeg" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="scroll-down">
            <a href="javascript:void(0);" (click)="scrollDown($event)" class="scroll-wrap"><span><img
                        src="assets/img/icon/down-arrow.svg" alt=""></span>
                Scroll Down</a>
        </div>
    </div>
</div>